import { LineChart } from "@tremor/react";
import { useState } from "react";

const Module2 = (props) => {
  const formatter = new Intl.NumberFormat("es-ES", {
    // minimumFractionDigits: 4,
    maximumFractionDigits: 4,
    // You can specify the separators explicitly
    // For example, to use dots for thousands and commas for decimals
    // Change these separators based on your preference
    useGrouping: true, // Enables the use of a separator for thousands
    // Change these separators based on your preference
    // Here, dots are used for thousands separator and commas for decimals
    // Change according to your desired format
    groupingSeparator: ".",
    decimalSeparator: ".",
  });
  const [optionSelected, setOptionSelected] = useState("Sale");
  const graphsYearsSale = props.indicators?.sale?.graph.find(
    (item) => item.id === "quarterly_evolution"
  ).categories;
  const graphsYearsRent = props.indicators?.rent?.graph.find(
    (item) => item.id === "quarterly_evolution"
  ).categories;

  // Seleccionar el año de acuerdo a la opción seleccionada
  const graphsYearsSelected =
    optionSelected === "Sale" ? graphsYearsSale : graphsYearsRent;

  // Extraer año de los timestamp
  const years = graphsYearsSelected.map((timestamp) => {
    const date = new Date(timestamp);
    return date.getFullYear();
  });

  const chartData = [];

  const graphsDataSaleNeighborhood = props.indicators?.sale?.graph
    ?.find((item) => item.id === "quarterly_evolution")
    .series.find((item) => item.id === "neighborhood").data1;
  const graphsDataRentNeighborhood = props.indicators?.rent?.graph
    ?.find((item) => item.id === "quarterly_evolution")
    .series.find((item) => item.id === "neighborhood").data1;

  const graphsDataSaleMunicipality = props.indicators?.sale?.graph
    ?.find((item) => item.id === "quarterly_evolution")
    .series.find((item) => item.id === "municipality").data1;
  const graphsDataRentMunicipality = props.indicators?.rent?.graph
    ?.find((item) => item.id === "quarterly_evolution")
    .series.find((item) => item.id === "municipality").data1;

  const fixSignal = (val) => {
    if (Number.isNaN(val)) {
      return "-";
    }
    // Check if the value is greater than or equal to 0
    if (val >= 0) {
      // If true, prefix with a "+"
      return "+" + val.toString();
    } else {
      // If false, just convert to string (negative sign is automatic)
      return val.toString();
    }
  };

  const saleYoyNeigh = props.indicators.sale.kpis.find(
    (item) => item.id === "neighborhood"
  ).yoy
    ? fixSignal(
        props.indicators.sale.kpis.find((item) => item.id === "neighborhood")
          .yoy
      )
    : "-";
  const saleYoyMuni = props.indicators.sale.kpis.find(
    (item) => item.id === "municipality"
  ).yoy
    ? fixSignal(
        props.indicators.sale.kpis.find((item) => item.id === "municipality")
          .yoy
      )
    : "-";
  const rentYoyNeigh = props.indicators.rent.kpis.find(
    (item) => item.id === "neighborhood"
  ).yoy
    ? fixSignal(
        props.indicators.rent.kpis.find((item) => item.id === "neighborhood")
          .yoy
      )
    : "-";
  const rentYoyMuni = props.indicators.rent.kpis.find(
    (item) => item.id === "municipality"
  ).yoy
    ? fixSignal(
        props.indicators.rent.kpis.find((item) => item.id === "municipality")
          .yoy
      )
    : "-";

  // Combinar los dos conjuntos de datos de Sale en un Array
  const combinedDataSale = graphsDataSaleNeighborhood.map((value, index) => [
    value,
    graphsDataSaleMunicipality[index],
  ]);

  // Combinar los dos conjuntos de datos de Rent en un Array
  const combinedDataRent = graphsDataRentNeighborhood.map((value, index) => [
    value,
    graphsDataRentMunicipality[index],
  ]);

  const graphsDataSelected =
    optionSelected === "Sale" ? combinedDataSale : combinedDataRent;

  // Asegurémonos de que graphsDataSelected tenga un valor antes de continuar
  if (graphsDataSelected) {
    let prevYear = 0;

    // get the starting quarter
    const firstYear = years[0];
    const countFirstYear = years.filter((value) => value === firstYear).length;
    let q = countFirstYear;
    for (let i = 0; i < graphsDataSelected.length; i++) {
      const [barrioValue, ciudadValue] = graphsDataSelected[i];
      let year = years[i];
      if (years[i] === prevYear) {
        q = q + 1;
      } else {
        if (years[i] === firstYear) {
          q = 5 - countFirstYear;
        } else {
          q = 1;
        }
      }
      year = `Q${q}/${years[i].toString().substring(2)}`;
      prevYear = years[i];

      chartData.push({
        year: year,
        Barrio: barrioValue,
        Ciudad: ciudadValue,
      });
    }
  }

  //   Eje Y version %
  const valueFormatter = (number) => `${number}€/m2`;

  const RadioOptionsStates = ["Sale", "Rent"];
  const getOptionLabel = (option) => {
    switch (option) {
      case "Sale":
        return "Venta";
      case "Rent":
        return "Alquilar";
      default:
        return "";
    }
  };
  const handleSeleccion = (option) => {
    setOptionSelected(optionSelected === option ? option : option);
  };

  return (
    <>
      {/* Module 2 */}
      <article className="w-full h-full tablet:p-[51px] p-5 parent-container">
        <div>
          <h1 className="text-[#2C2C2C] text-4xl font-semibold">
            Análisis de mercado de la zona
          </h1>
          <h2 className="text-[#656565] font-medium">
            Explora las tendencias, oportunidades y proyecciones clave para
            mejorar tu estrategia
          </h2>
        </div>
        {props.indicators.sale.graph &&
          props.indicators.rent.graph &&
          props.indicators.rent.kpis &&
          props.indicators.sale.kpis && (
            <div className="flex laptop:flex-row flex-col laptop:space-x-5 py-5 laptop:space-y-0 space-y-5">
              <div className="p-5 space-y-2 bg-[#F7F7F7] rounded-lg h-full">
                <div className="flex tablet:flex-nowrap flex-wrap items-center justify-between">
                  <span className="flex items-center">
                    <p className="w-10/12 text-[#3E3E3E] font-bold text-lg whitespace-nowrap">
                      Tiempo medio de venta
                    </p>
                  </span>
                  {/* <span className="bg-[#ECF3EC] rounded-full py-0.4 px-3">
                <p className="text-[#428542] font-semibold whitespace-nowrap">
                  {props.build_status}
                </p>
              </span> */}
                </div>
                <div>
                  <p className="text-[#656565] font-medium">Media del barrio</p>
                  <p className="text-3xl font-bold text-[#222222]">
                    {props.time_to_sale ? props.time_to_sale : "-"}
                    {props.time_to_sale === 1 ? " semana" : " semanas"}
                  </p>
                </div>
              </div>
              <div className="w-full p-5 space-y-2 bg-[#F7F7F7] rounded-lg">
                <div className="flex tablet:flex-row flex-col justify-between items-center tablet:space-y-0 space-y-2">
                  <span className="flex self-start">
                    <p
                      className="w-10/12 text-[#3E3E3E] font-bold text-lg whitespace-nowrap"
                      style={{ textAlign: "start" }}
                    >
                      Dinámica de precios
                    </p>
                  </span>
                  <span className="flex w-full items-center space-x-2 justify-end">
                    {RadioOptionsStates.map((option) => (
                      <label key={option} className="tablet:w-auto w-full">
                        <input
                          type="radio"
                          name="option"
                          className="hidden"
                          checked={optionSelected === option}
                          onChange={() => handleSeleccion(option)}
                        />
                        <button
                          type="button"
                          className={`border rounded-full py-1 tablet:w-24 w-full hover:bg-[#EEF2FB] whitespace-nowrap ${
                            optionSelected === option
                              ? "border-black"
                              : "text-[#A6A6A6] border-[#A6A6A6]"
                          }`}
                          onClick={() => handleSeleccion(option)}
                        >
                          <strong>{getOptionLabel(option)}</strong>
                        </button>
                      </label>
                    ))}
                  </span>
                </div>
                <div className="flex space-x-4">
                  <div className="space-y-1">
                    <p className="font-semibold text-[#747D93]">Barrio</p>
                    <span className="flex flex-wrap items-center">
                      <p className="text-[#3E3E3E] text-2xl font-bold price-dynamics-value-label">
                        {/* {optionSelected === "Sale" ? neighbourhoodSaleHistoricalMax : neighbourhoodSaleHistoricalMax} €/m2 */}
                        {optionSelected === "Sale"
                          ? `${
                              graphsDataSaleNeighborhood[
                                graphsDataSaleNeighborhood.length - 1
                              ] !== null
                                ? formatter.format(
                                    parseInt(
                                      Math.round(
                                        graphsDataSaleNeighborhood[
                                          graphsDataSaleNeighborhood.length - 1
                                        ]
                                      )
                                    )
                                  )
                                : "-"
                            } €/m2`
                          : `${
                              graphsDataRentNeighborhood[
                                graphsDataRentNeighborhood.length - 1
                              ] !== null
                                ? graphsDataRentNeighborhood[
                                    graphsDataRentNeighborhood.length - 1
                                  ]
                                : "-"
                            } €/m2`}
                      </p>
                      <p className="text-[#428542] font-medium bg-[#ECF3EC] px-3 rounded-full">
                        {optionSelected === "Sale"
                          ? saleYoyNeigh
                          : rentYoyNeigh}
                        % yoy
                      </p>
                    </span>
                  </div>
                  <div className="space-y-1">
                    <p className="font-semibold text-[#747D93]">Ciudad</p>
                    <span className="flex flex-wrap items-center">
                      <p className="text-[#3E3E3E] text-2xl font-bold price-dynamics-value-label">
                        {/* {optionSelected === "Sale" ? neighbourhoodSaleHistoricalMin : neighbourhoodRentHistoricalMin} €/m2 */}
                        {optionSelected === "Sale"
                          ? `${
                              graphsDataSaleMunicipality[
                                graphsDataSaleMunicipality.length - 1
                              ] !== null
                                ? formatter.format(
                                    parseInt(
                                      Math.round(
                                        graphsDataSaleMunicipality[
                                          graphsDataSaleMunicipality.length - 1
                                        ]
                                      )
                                    )
                                  )
                                : "-"
                            } €/m2`
                          : `${
                              graphsDataRentMunicipality[
                                graphsDataRentMunicipality.length - 1
                              ] !== null
                                ? graphsDataRentMunicipality[
                                    graphsDataRentMunicipality.length - 1
                                  ]
                                : "-"
                            } €/m2`}
                      </p>
                      <p className="text-[#428542] font-medium bg-[#ECF3EC] px-3 rounded-full">
                        {optionSelected === "Sale" ? saleYoyMuni : rentYoyMuni}%
                        yoy
                      </p>
                    </span>
                  </div>
                </div>
                <div>
                  {/* <div style={{
                display: "flex",
                width: "954px",
                height: "161px",
                padding: "var(--Spacing-spacing-0, 0px)",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "var(--Spacing-spacing-xs, 8px)",
                borderRadius: "var(--Spacing-spacing-ml, 24px)",
                background: "var(--Secondary-Aliseda-Grey_100, #ECECEC)"
              }}>
                <img src={noChartData} alt="" />
                <p style={{
                  color: "var(--Base-Global-Charcoal_800, #212632)",
                  fontFeatureSettings: "'clig' off, 'liga' off",
                  fontFamily: "Roboto",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "125%",
                }}>No existen datos suficientes en esta zona</p>
                <p style={{
                  color: "var(--Grey-grey-400, #656565)",
                  fontFeatureSettings: "'clig' off, 'liga' off",
                  
                  fontFamily: "Roboto",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "113%"
                }}>Esto sucede sobre todo en zonas con poco volumen y movimiento de activos</p>
              </div>
            {
              props.indicators ? (
                <div></div>
                ) : (
                  <div></div>
                  )
                } */}
                  <LineChart
                    className="h-60"
                    data={chartData}
                    index="year"
                    categories={["Barrio", "Ciudad"]}
                    colors={["orange", "gray"]}
                    valueFormatter={valueFormatter}
                    yAxisWidth={64}
                    autoMinValue={true}
                    curveType="monotone"
                    tickGap={8}
                  />
                </div>
              </div>
            </div>
          )}
      </article>
    </>
  );
};

export default Module2;
